/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Breakdown_Kind_Los_DiscountInputs */

const en_price_breakdown_kind_los_discount = /** @type {(inputs: Price_Breakdown_Kind_Los_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Length-of-stay discount`)
};

/**
* | output |
* | --- |
* | "Length-of-stay discount" |
*
* @param {Price_Breakdown_Kind_Los_DiscountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_breakdown_kind_los_discount = /** @type {((inputs?: Price_Breakdown_Kind_Los_DiscountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Breakdown_Kind_Los_DiscountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_breakdown_kind_los_discount(inputs)
});